<template>
    <div id="publish">
        <headers :title="titles"></headers>
        <loadingS v-if="loading"></loadingS>
        <div class="wraps"
             v-else>
            <p @click="setTime">
                发布时间
                <span class="up">
                    {{beginTime}}
                    <i class="icon-zhankai"></i>
                </span>
            </p>
            <p @click="setEndTime">
                完成时间
                <span class="down">
                    {{endTime}}
                    <i class="icon-zhankai"></i>
                </span>
            </p>
        </div>
        <div class="select_cs">
            <p class="cs_title">选择发布作业的班级</p>
            <div class="cs_list">
                <div v-for="(school,index) in school_list"
                     :key="index">
                    <span class="sc_name">{{school.school_name}}</span>
                    <p class="unit_name">
                        <span :class="{'nocheck':!un.choose,'check':un.choose}"
                              v-for="(un,inx) in school.units"
                              :key="inx"
                              @click="chooseClass(un,index,inx)">{{un.unit_name}}</span>
                    </p>
                </div>
            </div>
        </div>
        <div class="wraps select_cs">
            <p @click="setStu">
                短信通知
                <span v-if="!smsScope"
                      class="up">
                    班内所有学生
                    <i class="icon-zhankai"></i>
                </span>
                <span v-else
                      class="up">
                    仅开通学生
                    <i class="icon-zhankai"></i>
                </span>
            </p>
            <p @click="setMima()">
                是否下发账号密码
                <span v-if="!sendPwd"
                      class="up">
                    否
                    <i class="icon-zhankai"></i>
                </span>
                <span v-else
                      class="up">
                    是
                    <i class="icon-zhankai"></i>
                </span>
            </p>
        </div>
        <div class="message">
            <p class="msg_title">
                短信内容
            </p>
            <div>
                <textarea maxlength='200'
                          @input='smsChange'
                          v-model="duanxin">
          </textarea>
            </div>
        </div>
        <!-- 弹窗 -->
        <!-- 立即发送时间 -->
        <transition name="my-slide1"
                    tag="div">
            <div class="bottomChoose"
                 v-show="timeShow">
                <ul>
                    <li @click="time">立即发送</li>
                    <li @click="dingtime">定时发送</li>
                </ul>
            </div>
        </transition>
        <transition name="my-slide3"
                    tag="div">
            <div class="bottomChoose"
                 v-show="stuShow">
                <ul>
                    <li v-for="(stu,index) in chooseStu"
                        :key="index"
                        @click="Student(index)">{{stu.name}}</li>
                </ul>
            </div>
        </transition>
        <transition name="my-slide2"
                    tag="div">
            <div class="bottomChoose"
                 v-show="mimaShow">
                <ul>
                    <li v-for="(o,index) in chooseMima"
                        :key="index"
                        @click="Mima(index)">{{o.name}}</li>
                </ul>
            </div>
        </transition>
        <!-- 选择时间 -->
        <picker v-model="checkVisible"
                :data-items="partItems"
                @change="onDayChange">
            <div class="bottom-content clearfix"
                 slot="bottom-content">
                <span @click="quxiao">取消</span>
                <span class="btn"
                      @click="ok">确定</span>
            </div>
        </picker>
        <picker v-model="beginVisible"
                :data-items="beginItems"
                @change="onTimeChange">
            <div class="bottom-content clearfix"
                 slot="bottom-content">
                <span @click="bequxiao">取消</span>
                <span class="btn"
                      @click="beok">确定</span>
            </div>
        </picker>
        <transition name="my-fade"
                    tag="div">
            <div class="bottomMask"
                 @click="hideMask"
                 v-show="timeShow||stuShow||mimaShow"></div>
        </transition>
        <div class="foot"
             v-if="!loading"
             @click="go">发布作业</div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue';
import loadingS from 'SRC/components/base/loadingS.vue';

export default {
    data () {
        return {
            city_id: localStorage.getItem('city_id'),
            timeShow: false,//弹窗
            checkVisible: false,//选择天
            beginVisible: false,//选择时间
            partItems: [], //[{name:'name','values':[]}],
            beginItems: [],
            day: [], //日期列表
            timeList: [], //今天时间列表
            List: [], //小时列表
            endTime: "请选择（必填）",
            beginTime: "立即发送",
            today: {
                name: "",
                id: ""
            }, //今天
            lijiTime: "", //暂存定时发送日期
            lijiDay: "", //暂存定时发送时间
            oldDay: "", //定时发送存老时间
            timeId: "", //暂存定时日期id
            _dayId: "", //暂存定时时间id
            _end: "", //暂存时间
            _endtime: "", //暂存完成时间
            _endtimeid: "", //暂存完成时间id
            end_time: "", //数据里的完成时间
            begin_time: "", //数据里的开始时间
            dayId: "", //短信内的作业时间
            qidsArray: [],
            stuArray: [],
            _o: [], //已选发作业班级id
            duanxin: "", //短信内容
            // fabu_flag: true,
            fs_flag: 1,
            _betime: "",
            times_flag: false,//完成时间确定
            titles: '发布作业',
            school_list: [], //教师所带班级信息
            type: this.$route.params.type,//区别作业类型 1:课文预习 2同步习题 3单元复习 4高频错题 5生词听写 6 课外阅读
            textType: {
                1: "课文预习",
                2: "同步习题",
                3: "单元复习",
                4: "高频错题",
                5: "生词听写",
                6: "课外阅读",
                9: "开学大检查",
                12: "综合评价",
                13: "期中大检测"
            },
            sid: 51,
            loading: true, //加载学校信息的时候用
            info: localStorage.getItem('info') ? JSON.parse(localStorage.getItem('info')) : {},
            isSend: true,
            smsScope: 0,
            sendPwd: 0,
            sms_type: 1,
            chooseStu: [{
                name: "班内所有学生",
                id: 0
            }, {
                name: "仅开通学生",
                id: 1
            }],
            chooseMima: [{
                name: "是",
                id: 1
            }, {
                name: "否",
                id: 0
            }],
            mimaShow: false,
            stuShow: false,
            short_url: '',
            classArray: []
        }
    },
    computed: {
        teaName () {
            return this.info.real_name;
        },
        phone () {
            return this.info.phone;
        },
        sendData () {
            //所有发作业数据并以封装好
            if (this.type == 13 || this.type == 12 || this.type == 9) {//期末大检查
                let _data = { qid: JSON.parse(localStorage.getItem('schoolopenSend')).qid_list }
                return _data;
            } else {
                return this.$store.state.chinese.releaseid;
            }
        }
    },
    components: {
        headers,
        loadingS
    },
    beforeRouteLeave (to, from, next) {
        layer.closeAll();
        next();
    },
    destroyed () {
    },
    methods: {
        smsChange () {
            this.sms_type = 2;
            this.duanxin = this.duanxin.trim().slice(0, 200);
        },
        Student (i) {
            // this.stuName = this.chooseStu[i].name;
            this.smsScope = this.chooseStu[i].id;
            this.stuShow = false;
        },
        setStu () {//短信通知
            this.stuShow = true;
        },
        Mima (i) {
            // this.mima = this.chooseMima[i].name;
            this.sendPwd = this.chooseMima[i].id;
            this.mimaShow = false;
        },
        setMima () {
            this.mimaShow = true;
        },
        chooseClass (i, index, inx) { //班级的选择状态
            i.choose = !i.choose
            this.school_list[index].units.splice(inx, 1, i)

            // 选中年级集合
            this.classArray = []
            if (this.school_list.length) {
                this.school_list.forEach((m, n) => {
                    if (m.units.length) {
                        m.units.forEach((l, i) => {
                            if (l.choose) {
                                this.classArray.push(l.unit_class_id);
                            }
                        })
                    }
                })
            }
            console.log(this.classArray)
            this.getShortUrl()
            this.getdx()
        },
        hideMask () {
            this.timeShow = false;
        },
        setTime () {
            let platform = JSON.parse(localStorage.getItem('userInfo.city_id'));
            if (platform !== '130000') {
                this.timeShow = true;
            }
        },
        setEndTime () { //点击选择完成时间
            this.makeEndday();
            let _array = [{
                name: 'name',
                values: []
            }, {
                name: 'name',
                values: []
            }];
            let _daytime = new Date().getHours(); //现在小时
            let l = 12;
            if (_daytime >= 8 && _daytime < 19) { //时间在8点到19点之间
                _array[1].values = this.timeList; //今天的时间表
            } else if (_daytime < 8) { //时间在8点之前
                _array[1].values = this.List;
            } else if (_daytime >= 19) {
                _array[1].values = this.List;
            }

            _array[0].values = this.day;
            this.partItems = _array;
            this._endTime = _array[1].values[0].name; //暂存定时日期
            this._endDay = this.day[0].name; //暂存定时时间
            this.timeId = _array[1].values[0].id; //暂存定时时间id
            this._endtimeid = this.day[0].id; //暂存定时日期id
            this.checkVisible = true;
            this.setMsg({});
            console.log(this.partItems)
        },
        time () { //点击立即发送
            this.fs_flag = 1;
            this.beginTime = "立即发送";
            this.timeShow = false;
            this.dayId = "";
            this.timeId = "";
            this.begin_time = "";
            this.getdx()
        },
        dingtime () { //定时发送
            this.fs_flag = 2;
            this.makeDay();
            this.timeShow = false;
            let _array = [{
                name: 'name',
                values: []
            }, {
                name: 'name',
                values: []
            }];
            let _daytime = new Date().getHours(); //现在小时
            let l = 12;

            if (_daytime > 8 && _daytime < 19) { //时间在8点到19点之间
                _array[1].values = this.timeList; //今天的时间表
            } else if (_daytime <= 8) { //时间在8点之前
                _array[1].values = this.List;
            } else if (_daytime >= 19) {
                _array[1].values = this.List;
            }
            _array[0].values = this.day;
            this.beginItems = _array;
            this.lijiTime = _array[1].values[0].name; //暂存定时日期
            this.lijiDay = this.day[0].name; //暂存定时时间
            this.timeId = _array[1].values[0].id; //暂存定时时间id
            this._dayId = this.day[0].id; //暂存定时日期id
            this.beginVisible = true;

        },
        makeDay () { //定时时间使用
            let that = this;
            let t = 1000 * 60 * 60 * 24;
            let _time = new Date();
            let day = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            that.today.name = (_time.getMonth() + 1) + "月" + _time.getDate() + "日（" + day[_time.getDay()] + "）";
            if (_time.getMonth() + 1 < 10) {
                if (_time.getDate() < 10) {
                    that.today.id = _time.getFullYear() + "-0" + (_time.getMonth() + 1) + "-0" + _time.getDate();
                } else {
                    that.today.id = _time.getFullYear() + "-0" + (_time.getMonth() + 1) + "-" + _time.getDate();
                }
            } else {
                if (_time.getDate() < 10) {
                    that.today.id = _time.getFullYear() + "-" + (_time.getMonth() + 1) + "-0" + _time.getDate();
                } else {
                    that.today.id = _time.getFullYear() + "-" + (_time.getMonth() + 1) + "-" + _time.getDate();
                }
            }
            let _hours = _time.getHours();
            if (_hours >= 19) {
                _time = +_time + t;
            }
            let d = new Date(_time);
            let l = 20;
            let _dayList = []; //日期列表
            for (let i = 0; i < l; i++) {
                let obj_day = {};
                let _date = new Date(_time);
                if (_date.getDate() < 10) {
                    if ((_date.getMonth() + 1) < 10) {
                        obj_day.id = _date.getFullYear() + "-0" + (_date.getMonth() + 1) + "-0" + _date.getDate();
                    } else {
                        obj_day.id = _date.getFullYear() + "-" + (_date.getMonth() + 1) + "-0" + _date.getDate();
                    }
                } else {
                    if ((_date.getMonth() + 1) < 10) {
                        obj_day.id = _date.getFullYear() + "-0" + (_date.getMonth() + 1) + "-" + _date.getDate();
                    } else {
                        obj_day.id = _date.getFullYear() + "-" + (_date.getMonth() + 1) + "-" + _date.getDate();
                    }
                }
                obj_day.name = (_date.getMonth() + 1) + "月" + _date.getDate() + "日（" + day[_date.getDay()] + '）';
                _dayList.push(obj_day);
                _time = +_time + t;
            }
            that.day = _dayList;

            let _list = []; //小时列表
            let h = 12;
            let _h = 8;
            for (let i = 0; i < h; i++) {
                let new_time = {};
                if (_h < 10) {
                    new_time.id = "0" + _h + ":00:00";
                } else {
                    new_time.id = _h + ":00:00";
                }
                new_time.name = _h + "点";
                _list.push(new_time);
                _h = _h + 1;
            }
            that.List = _list;

            let dayHour = "";
            if (_hours < 8) {
                dayHour = 7;
            } else {
                dayHour = _hours;
            }
            let n = 19 - dayHour;
            let _timeList = []; //今天时间列表
            for (let i = 0; i < n; i++) {
                let new_time = {};
                if ((dayHour + 1) < 10) {
                    new_time.id = "0" + (dayHour + 1) + ":00:00";
                } else {
                    new_time.id = (dayHour + 1) + ":00:00";
                }
                new_time.name = (dayHour + 1) + "点";
                _timeList.push(new_time);
                dayHour = dayHour + 1;
            }
            that.timeList = _timeList;
        },
        makeEndday () {//结束时间使用
            let that = this;
            let t = 1000 * 60 * 60 * 24;
            let _time = new Date();
            let day = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            that.today.name = (_time.getMonth() + 1) + "月" + _time.getDate() + "日（" + day[_time.getDay()] + "）";
            if (_time.getMonth() + 1 < 10) {
                if (_time.getDate() < 10) {
                    that.today.id = _time.getFullYear() + "-0" + (_time.getMonth() + 1) + "-0" + _time.getDate();
                } else {
                    that.today.id = _time.getFullYear() + "-0" + (_time.getMonth() + 1) + "-" + _time.getDate();
                }
            } else {
                if (_time.getDate() < 10) {
                    that.today.id = _time.getFullYear() + "-" + (_time.getMonth() + 1) + "-0" + _time.getDate();
                } else {
                    that.today.id = _time.getFullYear() + "-" + (_time.getMonth() + 1) + "-" + _time.getDate();
                }
            }
            let _hours = _time.getHours();
            if (_hours >= 19) {
                _time = +_time + t;
            }
            let d = new Date(_time);
            let l = 20;
            let _dayList = []; //日期列表
            for (let i = 0; i < l; i++) {
                let obj_day = {};
                let _date = new Date(_time);
                if (_date.getDate() < 10) {
                    if ((_date.getMonth() + 1) < 10) {
                        obj_day.id = _date.getFullYear() + "-0" + (_date.getMonth() + 1) + "-0" + _date.getDate();
                    } else {
                        obj_day.id = _date.getFullYear() + "-" + (_date.getMonth() + 1) + "-0" + _date.getDate();
                    }
                } else {
                    if ((_date.getMonth() + 1) < 10) {
                        obj_day.id = _date.getFullYear() + "-0" + (_date.getMonth() + 1) + "-" + _date.getDate();
                    } else {
                        obj_day.id = _date.getFullYear() + "-" + (_date.getMonth() + 1) + "-" + _date.getDate();
                    }
                }
                obj_day.name = (_date.getMonth() + 1) + "月" + _date.getDate() + "日（" + day[_date.getDay()] + '）';
                _dayList.push(obj_day);
                _time = +_time + t;
            }
            that.day = _dayList;

            let _list = []; //小时列表
            let h = 24;
            let _h = 0;
            for (let i = 0; i < h; i++) {
                let new_time = {};
                if (_h < 10) {
                    new_time.id = "0" + _h + ":00:00";
                } else {
                    new_time.id = _h + ":00:00";
                }
                new_time.name = _h + "点";
                _list.push(new_time);
                _h = _h + 1;
            }
            that.List = _list;

            let dayHour = "";
            if (_hours < 8) {
                dayHour = 7;
            } else {
                dayHour = _hours;
            }
            let n = 23 - dayHour;
            let _timeList = []; //今天时间列表
            for (let i = 0; i < n; i++) {
                let new_time = {};
                if ((dayHour + 1) < 10) {
                    new_time.id = "0" + (dayHour + 1) + ":00:00";
                } else {
                    new_time.id = (dayHour + 1) + ":00:00";
                }
                new_time.name = (dayHour + 1) + "点";
                _timeList.push(new_time);
                dayHour = dayHour + 1;
            }
            that.timeList = _timeList;
        },
        ok () { //完成时间确定
            this.times_flag = true;
            let str = this.oldDay + this.timeId;
            let str1 = '';
            str1 = str.substring(0, str.length - 3);
            this.endTime = str1;
            this.end_time = this._endtimeid;
            this.checkVisible = false;
            this.makeDay();
            this.setMsg({});
            this.getdx();
        },
        quxiao () {
            this.checkVisible = false;
        },
        beok () {//定时发送时间确定
            this.dayId = this._dayId;
            this.beginTime = this.lijiDay + " " + this.lijiTime;
            this.begin_time = this._dayId + " " + this.timeId;
            this.beginVisible = false;
            this.getdx();
        },
        bequxiao () {
            this.beginVisible = false;
        },
        onDayChange (date, time) {//定时发送选择
            let _old = "";
            let _e = "";
            let that = this;
            if (date && _old != date.name) {
                that.oldDay = date.name;
                that._endtimeid = date.id; //暂存定时日期id
                that.partItems[1].values = that.List;
                let _today = that.today.name;
                if (date && _today == date.name) { //如果是今天就显示今天的时间列表
                    that.partItems[1].values = that.timeList;
                }
                that._endDay = date.name;
            }
            if (time && _e != time.name) {
                that._endTime = time.name;
                _e = time.name;
                that.timeId = time.id; //暂存定时时间id
            }
        },
        onTimeChange (date, time) {//完成时间选择
            let that = this;
            let _e = "";
            if (date && that.oldDay != date.name) {
                that.oldDay = date.name;
                that._dayId = date.id; //暂存定时日期id
                that.beginItems[1].values = that.List;
                let _today = that.today.name;
                if (date && _today == date.name) { //如果是今天就显示今天的时间列表
                    that.beginItems[1].values = that.timeList;
                }
                this.lijiDay = date.name;
            }
            if (time && _e != time.name) {
                this.lijiTime = time.name;
                _e = time.name;
                that.timeId = time.id; //暂存定时时间id
            }
        },
        go () {

            if (!this.isSend) return false;
            this.makeDay();

            let that = this;
            if (this.endTime == "请选择（必填）") {
                layer.open({
                    content: '请选择完成时间',
                    skin: 'msg',
                    time: 2
                });
            } else if (this.classArray.length == 0) {
                layer.open({
                    content: '请选择发布班级',
                    skin: 'msg',
                    time: 2
                });
            } else {
                let msg = {};
                this.stuArray = this.classArray;
                this.setMsg(msg);
                msg.content = this.duanxin;
                msg.phone = this.phone;
                let _text = this.duanxin.replace(/(^\s+)|(\s+$)/g, ""); //去掉前后空格
                if (_text == "") {
                    layer.open({
                        content: '短信不能为空',
                        skin: 'msg',
                        time: 2
                    });
                } else {
                    layer.open({
                        type: 2,
                        shadeClose: false,
                        content: '发送中'
                    });
                    this.isSend = false;
                    if (this.city_id == "411600" || this.type == 12) {
                        msg.content = this.duanxin;
                    }
                    else {
                        if (this.task_type == 2 || this.task_type == 3) {
                            msg.content = this.replaceSms(peroson) ? this.replaceSms(peroson) : msg.content;
                        } else {
                            msg.content = this.replaceSms() ? this.replaceSms() : msg.content;
                        }

                    }
                    msg.params = this.smsParams;
                    msg.sms_id = this.smsId;
                    this.$http.post(API_URL_TASK_API + '/chinese/send/task', msg).then(res => {
                        if (res.data.response == 'ok') {
                            let message_id = res.data.data;
                            if (this.type == 13 || this.type == 12 || this.type == 9) {//期末大检查
                                let kxd_data = {
                                    sid: 51,
                                    begin_time: this.begin_time == '' ? 0 : this.begin_time,
                                    unit_class_ids: msg.unit_class_ids,
                                    paper_id: JSON.parse(localStorage.getItem('schoolopenSend')).id,
                                    message_id: message_id
                                }
                                // /kxd2020/send_message_paper 期末大检查
                                this.$http.post(API_URL_HD_API + '/qm2020/send_message_paper', kxd_data).then(r => {
                                    if (r.data.response == 'ok') {
                                        // layer.alert('发送成功', 'tea', function () {
                                        layer.closeAll();
                                        that.clearTask();
                                        localStorage.setItem('chinese_send_ok', 1);
                                        msg._betime = that._betime

                                        that.$store.commit('setmsg', msg);
                                        localStorage.removeItem('schoolopenSend');
                                        let editionObj = JSON.parse(localStorage.getItem('editionObj')) || {};
                                        editionObj[51] = 0;
                                        localStorage.setItem('editionObj', JSON.stringify(editionObj));
                                        // that.$router.replace('/release/share?sid=5&message_id=' + message_id+'&subject=51');
                                        that.postMsg(msg, message_id);
                                        // })
                                    }
                                })
                            } else {
                                // layer.alert('发送成功', 'tea', function () {
                                // layer.closeAll();
                                that.clearTask();
                                localStorage.setItem('chinese_send_ok', 1);
                                localStorage.removeItem('paperIds');
                                msg._betime = that._betime
                                msg.content = this.duanxin
                                that.$store.commit('setmsg', msg);
                                // })
                                that.postMsg(msg, message_id);
                            }
                        } else {
                            // let r =
                            layer.closeAll()
                            layer.open({
                                content: res.data.message,
                                skin: 'msg',
                                time: 2
                            });
                        }
                        this.isSend = true;
                    })
                }
            }
        },
        postMsg (msg, message_id) {
            let that = this;
            let msgData = {
                unit_class_ids: msg.unit_class_ids,
                message_id: message_id,
                content: msg.content,
                sms_scope: this.smsScope,
                send_pwd: this.sendPwd,
                sid: msg.sid,
                phone: msg.phone,
                params: JSON.stringify(msg.params),
                sms_id: msg.sms_id,
                sms_type: this.sms_type,
                place_id: 6,//配置平台发送短信配置参数
            }
            if (this.city_id == "411600") {
                msgData.sms_type = 2;
            }
            if (this.type == 2 || this.type == 3) {
                msgData.place_id = 138
            }
            this.$http.post(API_URL_TASK_API + '/public/task/tea/send/message', msgData).then(res => {
                layer.closeAll();
                if (res.data.response == 'ok') {
                    layer.alert('发送成功', 'tea', function () {
                        layer.closeAll();
                        // that.$router.go(-2);
                        if (that.$route.params.type == 2 || that.$route.params.type == 3) {
                            that.$router.replace('/release/share?sid=5&message_id=' + message_id + '&subject=51&is_personal=1&type=' + that.$route.params.type);
                        } else {
                            that.$router.replace('/release/share?sid=5&message_id=' + message_id + '&subject=51');
                        }
                    })
                } else {
                    layer.closeAll()
                    layer.open({
                        content: res.data.message,
                        skin: 'msg',
                        time: 2
                    });
                }
                this.isSend = true;
            })
        },
        setMsg (msg) {
            // 整合发作业的数据
            let that = this;
            let _stu = [];
            _stu = that.stuArray;
            /*if(this.type==1){//课前预习
                        msg.message_type = 1;
                    }else{
                        msg.message_type = 2;
                    }*/
            msg.unit_class_ids = this.stuArray.join(',');
            msg.begin_time = this.begin_time;
            if (this.fs_flag == 1) {//立即发送
                let str = '';
                str = this.end_time + ' ' + this.endTime.slice(-5) + ':00';
                msg.end_time = str;
            }
            if (this.times_flag == true) {//选过完成时间
                if (this.end_time != '' && this.timeId != '') {
                    let str = '';
                    str = this.end_time + ' ' + this.endTime.slice(-5) + ':00';
                    msg.end_time = str;
                }
            } else {
                msg.end_time = this.end_time + ":00";
            }
            msg.type = this.type;//同步习题的type=0,在上一个页面就变成了2，QAQ
            if (this.type == 2) {
                msg.type = 16
            }
            if (this.type == 3) {//单元复习的的type=1,在上一个页面就变成了3，QAQ
                msg.type = 17
            }
            // msg.data = JSON.stringify(this.sendData);
            msg.details = this.sendData;
            msg.sid = this.sid;
        },
        clearTask () {
            //1:课文预习 2同步习题 3单元复习 4高频错题 5生词听写 6 课外阅读
            this.$store.commit('setreleaseid', []);//清空同步习题本地存储
            // this.$store.commit('setSendData', []);//清空发布作业详情
            this.$store.commit('setchapterid', []);
        },
        getdx () {
            let _betime = '';
            if (this.dayId === "") {
                _betime = this.today.id;
                this._betime = _betime;
            } else {
                _betime = this.dayId;
                this._betime = _betime;
            }

            let str = this.endTime.slice(-5);
            let now_time = this.end_time + " " + str;
            let appcome = "同步课堂";
            let text_title = this.type == 12 ? '期末复习内容' : '学习内容';
            if (this.city_id == "411600") {
                appcome = "随堂练";
                if (this.times_flag == true) {//选过完成时间
                    this.duanxin = "家长您好，今天（" + this._betime + "）语文的" + text_title + "已发到" + appcome + "手机APP，截止至：" + now_time + "，请及时登录手机客户端查看。 【" + this.teaName + "老师】";
                } else {
                    this.duanxin = "家长您好，今天（" + this._betime + "）语文的" + text_title + "已发到" + appcome + "手机APP，截止至：" + this.end_time + "，请及时登录手机客户端查看。 【" + this.teaName + "老师】";
                }
            }
            else {
                //语文 个性化学习的
                if (this.type == 2 || this.type == 3) {
                    let _time = this.times_flag ? now_time : this.end_time;
                    //console.log(url)
                    this.duanxin = `家长您好，今天（${this._betime}）语文的学习内容已发布，截止至：${this.end_time}，请点击${this.short_url}或关注“精准教学系统”微信公众号完成。【${this.teaName}老师】`;
                    this.smsParams = {
                        'now_time': this._betime,
                        'end_time': _time,
                        'subject': '语文',
                        'url': this.short_url,
                        'task_type': this.textType[this.type],
                        'user_name': this.teaName
                    }
                    return
                }
                let _time = this.times_flag ? now_time : this.end_time;
                this.duanxin = `家长您好，今天（${this._betime}）语文的${text_title}已发到${appcome}，截止至：${_time}，请及时登录同步课堂（m.tbkt.cn）查看。【${this.teaName}老师】`;
                this.smsParams = {
                    'now_time': this._betime,
                    'end_time': _time,
                    'subject': '语文',
                    'task_type': this.textType[this.type],
                    'user_name': this.teaName
                }
            }
        },
        /**获取分享短链地址 */
        getShortUrl () {
            let unit_ids = this.classArray.join(',')
            let url = `${WAP_URL}/qr/special?is_sum=1&is_share=2&sid=${this.sid}&unit_ids=${unit_ids}`
            this.$http.post(API_URL_SORT_API + '/create_sort/', {
                url: url,
                sort_type: 1
            }).then((res) => {
                if (res.data.response === 'ok') {
                    this.short_url = res.data.data.short_url
                }
                this.getdx()
            })
        },
        class_list () {
            // 获取教师所带的班级
            this.$http.post(API_URL_BASE_API + '/unit/region/class_list/', {
                'phone': this.phone,
                'sid': this.sid,
                'user_type': 3  // 1-学生, 3-教师
            }).then((res) => {
                if (res.data.response === 'ok') {

                    this.loading = false;
                    let re = res.data.data.school_list;
                    this.school_list = res.data.data.school_list;
                    this.school_list.forEach((m, n) => {
                        m.units.forEach((l, i) => {
                            l.choose = true
                            this.classArray.push(l.unit_class_id);
                        })
                    })

                }
                this.getShortUrl()
            })
        },
        /**获取短信内容 */
        getSms () {
            let sms_id = 3
            if (this.type == 2 || this.type == 3) {
                sms_id = 55  //个性化学习传参55，其他不变
            }
            return new Promise((resolve, reject) => {
                this.$http.post(API_URL_BASE_API + '/sms/get_sms/', {
                    "sms_id": sms_id
                }).then(res => {
                    if (res.data.response == 'ok') {
                        this.smsContent = res.data.data.content;
                        this.smsId = res.data.data.id;
                    }
                    resolve(res);
                })
            })
        },
    },
    async created () {

        this.makeDay();
        this.getSms()
        await this.class_list();
        let _day = {
            name: 'name',
            values: []
        };
        _day.values = this.day;
        if (!this.partItems.length) {
            this.partItems.push(_day);
        }
        var date = new Date();
        this.lijiTime = this.day[0].name;
        this.timeId = this.day[0].id + ' ' + date.getHours() + ":" + date.getMinutes();

        this._endTime = this.day[0].name;
        this._endtimeid = this.day[0].id + ' 23:00';
        this.endTime = this._endTime + ' 23:00'; //完成默认时间当前24：00
        this.end_time = this._endtimeid;
        this.setMsg({});

        let that = this;
        //console.log(this.sendData)
        if (!this.sendData || this.sendData.length == 0) {//没有发布数据，返回
            this.$router.go(-1);
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#publish {
    padding-bottom: 120px / $ppr;
}

.icon-zhankai {
    display: inline-block;
    width: 0.35rem;
    height: 0.65rem;
    background: url("./img/enter.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    top: 5px / $ppr;
}

.bottomMask {
    position: fixed;
    z-index: 998;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: $mask;
    transition: background-color 0.3s linear;
}

//底部弹层选择
.bottomChoose {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: $c-fbg;
    transition: bottom 0.3s linear;
    li {
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        border-bottom: 1px / $ppr solid $line;
        text-align: center;
        font-size: 36px / $ppr;
        color: #333;
    }
}

.wraps {
    background-color: $c-fbg;
    p {
        font-size: $md;
        height: 90px / $ppr;
        line-height: 90px / $ppr;
        padding: 0 $w;
        span {
            float: right;
            color: $c-light;
            i {
                color: $c-light;
                margin-left: 15px / $ppr;
            }
        }
        .up,
        .down {
            color: $c-theme;
        }
    }
    p:nth-child(2) {
        border-top: 1px / $ppr solid $line;
    }
    .line {
        border-top: 1px / $ppr solid $line;
    }
}

.foot {
    position: fixed;
    bottom: 0;
    height: $h-header;
    line-height: $h-header;
    width: 100%;
    background-color: $c-theme;
    color: $c-header;
    font-size: $lg;
    text-align: center;
}

.bottom-content {
    background: $c-fbg;
    display: flex;
    display: -webkit-flex;
    span {
        flex: 1;
        -webkit-flex: 1;
        display: inline-block;
        text-align: center;
        font-size: $lg;
        line-height: $h-header;
    }
    .btn {
        color: $c-tag;
    }
}

.picker-backdrop,
.picker-wrapper {
    position: fixed;
    bottom: 0;
}

.select_cs {
    width: 100%;
    margin: 0 auto;
    margin-top: 24px / $ppr;
    background: #fff;
    overflow: hidden;
    .cs_title {
        padding: 0 $w;
        color: #333;
        font-size: $md;
        line-height: 90px / $ppr;
    }
    .cs_list {
        width: 100%;
        .sc_name {
            border-top: 1px / $ppr solid #dcdcdc;
            display: inline-block;
            width: 100%;
            //height: 80px/$ppr;
            //line-height: 100px/$ppr;
            margin: 0;
            padding: 32px / $ppr 0.6rem 0;
            // padding-top:32px/$ppr ;
            color: #a9a9a9;
        }
        .unit_name {
            width: 100%;
            padding: 0 0.3rem;
            span {
                display: block;
                float: left;
                width: 142px / $ppr;
                height: 56px / $ppr;
                margin: 24px / $ppr 0.35rem 32px / $ppr;
                text-align: center;
                line-height: 56px / $ppr;
                box-sizing: border-box;
                &.check {
                    width: 142px / $ppr;
                    height: 56px / $ppr;
                    background: url("./img/icon_choose.png") no-repeat;
                    background-size: 100%;
                    color: #fff;
                }
                &.nocheck {
                    width: 142px / $ppr;
                    height: 56px / $ppr;
                    border: 1px / $ppr solid #e8e8e8;
                    box-sizing: border-box;
                    background: #f7f7f7;
                    color: #999;
                    border-radius: 10px / $ppr;
                }
            }
        }
    }
}
.message {
    width: 100%;
    margin: 24px / $ppr auto 50px / $ppr;
    background: #fff;
    padding-bottom: 24px / $ppr;
    .msg_title {
        padding: 0 $w;
        height: 90px / $ppr;
        line-height: 90px / $ppr;
        font-size: 28px / $ppr;
        color: #333;
        border-bottom: 1px / $ppr solid $line;
    }
    textarea {
        width: 633px / $ppr;
        margin: 24px / $ppr auto 0;
        display: block;
        height: 190px / $ppr;
        color: #999;
        background: #f7f7f7;
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
        border: none;
        font-size: 0.7rem;
        line-height: 1.2rem;
    }
    .msg_txt {
        width: 673px / $ppr;
        margin: 0 auto;
        background: #f7f7f7;
        color: #999;
        margin: 0 auto;
        border-radius: 10px / $ppr;
        p {
            padding: 10px / $ppr 20px / $ppr;
            line-height: 48px / $ppr;
        }
    }
}
.my-fade-enter,
.my-fade-leave-to {
    background-color: rgba(0, 0, 0, 0);
}
.my-slide1-enter,
.my-slide1-leave-to,
.my-slide2-enter,
.my-slide2-leave-to,
.my-slide3-enter,
.my-slide3-leave-to {
    bottom: -192px / $ppr;
}
</style>
